import { Component, OnInit, ViewChild, OnDestroy, ElementRef,AfterViewInit } from '@angular/core';
import {
  NavigationStart,
  NavigationEnd,
  Routes,
  RouterModule,
  Router,
} from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
//import { HttpErrorInterceptorProvider } from './http-error-interceptor.service';
import { HttpErrorInterceptorService } from './http-error-interceptor.service';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import storageAvailable from 'storage-available';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit{
 
  title = 'angular-interceptor-loader';
  @ViewChild('content') contentModal: ElementRef;
  constructor(private router: Router, public http: HttpClient, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.router.events.subscribe((val) => {
      
      if(val instanceof NavigationEnd){
        document.querySelector('html').classList.forEach((val)=>{
          document.querySelector('html').classList.remove(val);
        })
        if(val.url.substring(1)){
          document.querySelector('html').classList.add(val.url.substring(1));
        }
      }
      
    });
  }

  ngAfterViewInit(){
    if (!storageAvailable('localStorage')) {
      this.open(this.contentModal);
    }
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
  } 
  ngOnDestroy() {
  }

  makeHttpCall() {
    this.http
      .get('https://jsonplaceholder.typicode.com/comments')
      .subscribe((r) => {});
  }
}
